<template>
  <v-container fluid>
    <el-breadcrumb separator-class="el-icon-arrow-right" class="mb-3">
      <el-breadcrumb-item :to="{ path: '/' }">แดชบอร์ด</el-breadcrumb-item>
      <el-breadcrumb-item>ประวัติการใช้งาน</el-breadcrumb-item>
    </el-breadcrumb>

    <v-row row wrap class="text-center">
      <v-col :cols="12">
        <el-date-picker
          size="small"
          v-model="daterange"
          type="daterange"
          value-format="yyyy-MM-dd"
          format="dd/MM/yyyy"
          range-separator="To"
          start-placeholder="Start date"
          end-placeholder="End date"
        ></el-date-picker>
        <el-button type="primary" class="ml-2" size="mini" @click="fetch()"
          >ค้นหา</el-button
        >
        <!--
        <el-button type="primary" class="ml-2" size="mini" @click="downloadReport">ดาวน์โหลด</el-button>
        -->
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="12">
        <el-card class="mt-3">
          <v-data-table
            :headers="headers"
            :items="results"
            :loading="isLoading"
            :page.sync="page"
            :items-per-page="itemsPerPage"
            :mobile-breakpoint="`10`"
            @page-count="pageCount = $event"
            hide-default-footer
            class="elevation-0"
          >
            <template v-slot:item.user="{ item }">
              {{ item.user.firstname }} {{ item.user.lastname }}
            </template>
          </v-data-table>
        </el-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import Service from "@/services";
import moment from "moment";
export default {
  components: {},
  props: [],
  data() {
    return {
      isLoading: true,
      daterange: [moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")],
      headers: [
        {
          text: "#",
          align: "left",
          sortable: false,
          value: "id",
        },
        { text: "", value: "action", sortable: false },
        { text: "วันที่", value: "createdAt", sortable: false },
        { text: "รหัสสมาชิก", value: "memberId", sortable: false },
        { text: "ชื่อสมาชิก", value: "user", sortable: false },
        { text: "เบอร์มือถือ", value: "user.mobile", sortable: false },
        { text: "ร้านค้า", value: "branch.shop_name", sortable: false },
        { text: "ประเภท", value: "type", sortable: false },
        { text: "คะแนน", value: "points", sortable: false },
      ],
      results: [],
      page: 1,
      itemsPerPage: 1000,
      pageCount: 0,
      refresh: null,
    };
  },
  created() {
    this.isLoading = false;
    let params = {
      begin: "2021-12-01",
      end: "2021-12-11",
    };
    Service.Report.memberShipTransation(params).then((res) => {
      this.results = res.data;
    });
  },
  methods: {
    fetch() {
      let params = {
        begin: this.daterange[0],
        end: this.daterange[1],
        report: true,
        type: "view",
      };
      Service.Report.memberShipTransation(params).then((res) => {
        this.results = res.data;
      });
    },
  },
};
</script>
